/**
 * @author caijianjia
 * @date 2020/4/13 3:29 下午
 */

import COS from 'cos-js-sdk-v5'
import BMF from 'browser-md5-file'
import { Loading } from 'element-ui'
// import lamejs from 'lamejs'
let ele = null
let Vuex = null
let Tencent = null

console.log(Vuex, Tencent)

export const setVuex = a => {
    Vuex = a;
    return Vuex;
};

// 创建一个文本上传标签，并点击
export function clickFile({isPPT = false, isPlat= false, accept, callback, backType, cancelBack, isLoading = false}){
    Tencent = isPlat ? Vuex.state.tencentPlatform : Vuex.state.tencent
    ele = document.createElement('input')
    ele.type = 'file'
    ele.accept = accept
    ele.click()
    ele.addEventListener('change',()=>upLoad({isPPT, isPlat, callback, backType, cancelBack, target: ele, isLoading}))
}

// 真正上传文件
// 上传文件
export function upLoad ({isPPT, isPlat= false, fileName, file, callback, backType, cancelBack, target, isLoading = false}) {
    if(target && target.files && target.files.length === 0) {
        callback && cancelBack()
        return false
    }
    Tencent = isPlat ? Vuex.state.tencentPlatform : Vuex.state.tencent
    let newFileName = fileName || ele.files[0].name
    let newFile = file || ele.files[0]

    // debugger
    const name = `${newFileName}`
    const bmf = new BMF()
    let  loadingInstance = null
    if(isLoading&&isPPT){
      loadingInstance = Loading.service({
        lock: true,
        text: '正在初始化导入数据，请耐心等待...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        color: '#FAAD14'
      })
    }
    bmf.md5(
        newFile,
        (err, md5) => {
            console.log('err:', err)
            console.log('md5 string:', md5) // md5
            console.log('newFile==>', newFileName, newFile)
            let arr = newFileName.split('.')
            newFileName = md5 + '.' + arr[arr.length - 1]
            // 分组存储
            if(Tencent.resource_meta.resource_dir){
                newFileName = Tencent.resource_meta.resource_dir + newFileName
            }
            const cos = new COS({
                SecretId: Tencent.resource_token.credentials.tmpSecretId,
                SecretKey: Tencent.resource_token.credentials.tmpSecretKey,
                XCosSecurityToken: Tencent.resource_token.credentials.sessionToken,
                ExpiredTime: Tencent.resource_token.expiredTime
            })

            cos.putObject({
                'x-cos-meta-fileName': encodeURIComponent(newFileName),
                Bucket: Tencent.resource_meta.bucket,
                Region: Tencent.resource_meta.region,
                Key: newFileName,
                Body: newFile,
                EnableMD5: true, // 开启md5自定义
                'x-cos-meta-md5': md5
            }, function (err, data) {
                console.log('cos==>', err, data)
                // 如果上传token失效自动刷新页面
                if (err && err.statusCode === 403) {
                    self.$message.error('正在刷新！')
                    window.location.reload()
                }
                const url = `https://${data.Location}`
                if (backType === 'object') {
                    callback({
                        name,
                        ...data,
                        url,
                        loadingInstance
                    })
                    return false
                }
                callback(url)
            })
        },
        progress => {
            console.log('progress number:', progress)
        }
    )
}
// // wav数据流转成mp3 - 测试未通过
// export function convertWavToMp3(wavDataView) {
//     const wav = lamejs.WavHeader.readHeader(wavDataView);
//     const samples = new Int16Array(wavDataView.buffer, wav.dataOffset, wav.dataLen / 2);
//     const { channels, sampleRate } = wav;
//     const buffer = [];
//     const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
//     let remaining = samples.length;
//     const maxSamples = 1152;
//     for (let i = 0; remaining >= maxSamples; i += maxSamples) {
//         const mono = samples.subarray(i, i + maxSamples);
//         const mp3buf = mp3enc.encodeBuffer(mono);
//         if (mp3buf.length > 0) {
//             buffer.push(new Int8Array(mp3buf));
//         }
//         remaining -= maxSamples;
//     }
//     const d = mp3enc.flush();
//     if (d.length > 0) {
//         buffer.push(new Int8Array(d));
//     }
//
//     return new Blob(buffer, { type: 'audio/mp3' });
// }

/***
 * 将远端地址转成文件流 图片｜音频
 * @param url 远端地址
 * @param callback 回调函数
  */

export function getFileStream({url, callback}){
    loadImageToBlob(url, function(blobFile) {//这里的img.src改地址
        if(!blobFile) return false;
        //生成二进制流
        callback && callback(blobFile)
        // console.log(blobFile)


        // return blobFile
        // var fileReader = new FileReader();
        // fileReader.readAsDataURL(blobFile);
        // fileReader.onload = function() {
        //     console.log(this.result);//这里输出的数据放到url里能生成图片，或者post回后台生成mp3，二进制流
        // };
        //
        // //生成url可以用于页面显示
        //
        // result1.innerHTML = '<a download href="' + window.URL.createObjectURL(blobFile) + '" target="_blank">文件下载</a>';
    });
}
export function loadImageToBlob(url, callback) {
    if(!url || !callback) return false;
    let xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
    // 注意这里的this.response 是一个blob对象 就是文件对象
        callback(this.status === 200 ? this.response : false);
    }
    xhr.send();
    return true;
}
